var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.$session?.permissions.any('PAY_ORDER', 'VD_RENEW', 'SHOW_ALL_MENUS') )&& _vm.show)?_c('el-button',{staticClass:"batch-operate-btn",attrs:{"type":"text","data-matomo":_vm.$store.state.matomo[19].id},on:{"click":_vm.batchRenew}},[_vm._v(" "+_vm._s(_vm.$t("vdcontainer.renewal_multi_new_vd"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }